var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-flex-center"},[_c('img',{staticClass:"image",staticStyle:{"height":"60px"},attrs:{"src":_vm.imageUrl,"alt":"CAPTCHA Image"}}),_vm._v(" "),_c('button',{staticClass:"button is-small ml-2",attrs:{"type":"button"},on:{"click":_vm.refresh}},[_c('b-icon',{attrs:{"icon":"refresh","size":"is-small"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }